export default __webpack_public_path__ + "056eb3f9e1b27f6f6c616bc16745bcb0.png";